/**
 * RoomsScreen — elenco delle stanze che HO CREATO (gestione + cap 3) e accessi
 * "crea" / "entra con codice". Gated dal feature-flag (founder per ora).
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Frame, Header, Footer, Btn, Box } from '../components/Frame';
import { useStore } from '../lib/store';
import { roomsVisible } from '../lib/features';
import { listMyRooms } from '../lib/rooms';

export default function RoomsScreen() {
  const navigate = useNavigate();
  const { sigil } = useStore();
  const [rooms, setRooms] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!roomsVisible(sigil)) { navigate('/inbox', { replace: true }); return; }
    listMyRooms().then(setRooms).catch((e) => setErr(e.message));
  }, [sigil, navigate]);

  const open = (rooms || []).filter((r) => r.status === 'open');

  return (
    <Frame statusLeft="STANZE" statusRight="">
      <Header title="// Stanze" crumb="◀ indietro" onCrumbClick={() => navigate(-1)} />
      <p className="text-[14px] text-ink-dim mb-4 leading-relaxed">
        Stanze <b>private ed effimere</b>: entra solo chi inviti tu, e quando vuoi le <b>bruci</b>.
        Dentro appari con un'identità <b>usa-e-getta</b> — gli altri non vedono il tuo sigil.
      </p>
      {err && <Box variant="danger" className="text-[14px] text-red-400 mb-3">{err}</Box>}
      <Box className="mb-3">
        <p className="text-ink text-glow text-[15px] mb-1">Le mie stanze ({open.length}/3)</p>
        {rooms === null ? (
          <p className="text-ink-dim text-[14px]">…</p>
        ) : open.length === 0 ? (
          <p className="text-ink-dim text-[14px]">nessuna stanza aperta</p>
        ) : open.map((r) => (
          <button key={r.roomId} onClick={() => navigate(`/room/${r.roomId}`)}
            className="block w-full text-left border-t border-ink-faint py-2 hover:text-ink">
            <span className="text-ink">{r.type === 'work' ? '🛠 lavoro' : '🎉 evento'}</span>
            <span className="text-ink-dim text-[13px]"> · {r.memberCount}/{r.memberCap} membri</span>
          </button>
        ))}
      </Box>
      <Footer>
        <Btn variant="primary" onClick={() => navigate('/room/new')} disabled={open.length >= 3}>
          ＋ Crea una stanza
        </Btn>
        <Btn onClick={() => navigate('/room-join')}>🔑 Entra con un codice</Btn>
      </Footer>
    </Frame>
  );
}
